
























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType,
    pageDataType
} from "../types";

import {
    HOST
} from "../global";

@Component({
    name: "BrandSingleTitle",

})
export default class BrandSingleTitle extends Vue {
    @Prop() public compData!: string | null;

}
